import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { API } from "../api";

export const roomsQueryOptions = (eventId: string) =>
  queryOptions({
    queryKey: ["rooms", eventId],
    queryFn: async () => {
      const response =
        await API.accommodationRooms.accommodationRoomsControllerFindAll(
          eventId
        );
      return response.data;
    },
  });

export const useRooms = (eventId: string) => {
  return useQuery(roomsQueryOptions(eventId));
};

export const useRoomsSuspense = (eventId: string) => {
  return useSuspenseQuery(roomsQueryOptions(eventId));
};
